class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    /* SNKL 2026-10-07: 400 ms zamiast Dawnowych 800 — szybsza reakcja na pojedyncze
       kliknięcie, nadal łapie kilka szybkich zaznaczeń w jedno żądanie. */
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 400);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const updateEvent = FacetFiltersForm.startUpdateEvent(searchParams);
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, updateEvent)
        : FacetFiltersForm.renderSectionFromFetch(url, event, updateEvent);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static startUpdateEvent(searchParams) {
    const { SearchUpdateEvent, CollectionUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent && !CollectionUpdateEvent) return;

    const facetsForm = document.querySelector('facet-filters-form');
    const facetsContainer = document.querySelector('.facets-container');
    const collectionId = facetsContainer?.dataset.collectionId || null;
    const collectionHandle = facetsContainer?.dataset.collectionHandle || '';
    const currentCount = parseInt(document.getElementById('ProductCount')?.dataset.productCount) || 0;
    const urlSearchParams = new URLSearchParams(searchParams);
    const isSearchPage = facetsContainer?.dataset.template === 'search';
    const isCollectionPage = facetsContainer?.dataset.template === 'collection';
    const dispatchTarget = facetsForm || document;

    let deferred;

    if (isSearchPage) {
      deferred = SearchUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new SearchUpdateEvent({
          search: {
            query: urlSearchParams.get('q') || '',
            productFilters: SearchUpdateEvent.parseProductFilters(urlSearchParams),
            sortKey: SearchUpdateEvent.getSortKey(urlSearchParams),
          },
          promise: deferred.promise,
        }),
      );
    } else if (isCollectionPage) {
      // collectionId is null for auto-generated collections (/collections/all,
      // /collections/vendors/<x>, etc.) — the SSE schema accepts that.
      deferred = CollectionUpdateEvent.createPromise();
      dispatchTarget.dispatchEvent(
        new CollectionUpdateEvent({
          collection: { id: collectionId, handle: collectionHandle, productsCount: currentCount },
          productFilters: CollectionUpdateEvent.parseProductFilters(urlSearchParams),
          sortKey: CollectionUpdateEvent.getSortKey(urlSearchParams),
          promise: deferred.promise,
        }),
      );
    }

    if (!deferred) return;

    return {
      resolve: (filteredCount) => {
        deferred.resolve({ [isSearchPage ? 'totalCount' : 'productsCount']: filteredCount });
      },
      reject: deferred.reject,
    };
  }

  static renderSectionFromFetch(url, event, updateEvent) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderSection(html, event, updateEvent);
      })
      .catch((error) => {
        console.error(error);
        updateEvent?.reject(error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, updateEvent) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event, updateEvent);
  }

  static renderSection(html, event, updateEvent) {
    // AUDYT 2026-08-04: jedna wspolna DOMParser-owa kopia odpowiedzi (~0.9MB HTML)
    // zamiast TRZECH niezaleznych parsowan (filters/grid/count) - 2/3 mniej pracy
    // na watku glownym przy kazdym kliku filtra (INP).
    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    FacetFiltersForm.renderFilters(parsedDoc, event);
    FacetFiltersForm.renderProductGridContainer(parsedDoc);
    FacetFiltersForm.renderProductCount(parsedDoc, updateEvent);
    // `html` to STRING odpowiedzi, wiec `html.innerHTML` bylo `undefined` i funkcja
    // dzialala wylacznie dzieki domyslnemu parametrowi (rootEl = document).
    // Zapisane wprost, zeby nie wygladalo na przekazanie zakresu.
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(document);
  }

  static renderProductGridContainer(parsedDoc) {
    document.getElementById('ProductGridContainer').innerHTML =
      parsedDoc.getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(parsedHtml, updateEvent) {
    const sourceCount = parsedHtml.getElementById('ProductCount');
    const count = sourceCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.dataset.productCount = sourceCount.dataset.productCount || '';
    container.dataset.totalCount = sourceCount.dataset.totalCount || '';
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    updateEvent?.resolve(parseInt(sourceCount.dataset.productCount) || 0);
  }

  static renderFilters(parsedHTML, event) {
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (!isTextInput) {
          // Try to return focus to the same checkbox the user just toggled,
          // re-selecting it from the freshly rendered HTML by its id.
          const originatingInputId = event.target.id;
          const matchingInput = originatingInputId
            ? newFacetDetailsElement.querySelector(`#${CSS.escape(originatingInputId)}`)
            : null;

          if (matchingInput) {
            matchingInput.focus();
          } else {
            // Fallback to summary/close button if the checkbox can't be found
            const fallbackSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
              ? `.mobile-facets__close-button`
              : `.facets__summary`;
            const fallbackElement = newFacetDetailsElement.querySelector(fallbackSelector);
            if (fallbackElement) fallbackElement.focus();
          }
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* SNKL 2026-09-04: jedna lista wartosci filtrow w HTML (waga strony / SEO).
   Przy filtrach poziomych i pionowych serwer oddaje szuflade mobilna
   (#FacetFiltersFormMobile) z PUSTYMI <ul data-snkl-from="Details-…">, a wartosci
   klonujemy z formularza desktopowego (#FacetFiltersForm). Zmierzone na
   /collections/mezczyzni: formularz mobilny 344 KB z 1 137 KB strony, kopia 1:1.
   Dawn po kazdej zmianie filtra podmienia innerHTML OBU formularzy trescia
   z serwera (renderFilters, renderMobileCounts) - mobilne listy wracaja puste,
   wiec klonowanie musi isc PO renderFilters. Stad opakowanie metody statycznej,
   nie osobny listener. Klon dostaje dokladnie te atrybuty, ktore ma wersja SSR
   szuflady: klasa `mobile-facets__checkbox` (facets.js porownuje className
   PRZEZ ROWNOSC), id z sufiksem `-mobile-N`, highlight tuz za inputem
   (`:checked + .mobile-facets__highlight`), a swatch dostaje form="…Mobile"
   (input z atrybutem form nie liczy sie do FormData innego formularza). */
(function () {
  function snklFillMobileFacets() {
    var lists = document.querySelectorAll('#FacetFiltersFormMobile ul[data-snkl-from]');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.children.length) continue;
      var source = document.getElementById(list.getAttribute('data-snkl-from'));
      if (!source) continue;
      var items = source.querySelectorAll('.facets__list > li, .facets__list--vertical > li');
      var frag = document.createDocumentFragment();
      for (var j = 0; j < items.length; j++) {
        var clone = items[j].cloneNode(true);
        clone.className = 'mobile-facets__item list-menu__item';
        var label = clone.querySelector('.facet-checkbox');
        if (label) label.className = label.className.replace('facet-checkbox', 'mobile-facets__label');
        var inputs = clone.querySelectorAll('input');
        for (var k = 0; k < inputs.length; k++) {
          var input = inputs[k];
          if (input.id) {
            var id = input.id.replace(/-(\d+)$/, '-mobile-$1');
            var fors = clone.querySelectorAll('label[for="' + input.id + '"]');
            for (var m = 0; m < fors.length; m++) fors[m].setAttribute('for', id);
            input.id = id;
          }
          if (input.classList.contains('swatch-input__input')) {
            input.setAttribute('form', 'FacetFiltersFormMobile');
          } else {
            input.className = 'mobile-facets__checkbox';
            var highlight = document.createElement('span');
            highlight.className = 'mobile-facets__highlight';
            input.insertAdjacentElement('afterend', highlight);
          }
        }
        frag.appendChild(clone);
      }
      list.appendChild(frag);
    }
  }
  var snklRenderFilters = FacetFiltersForm.renderFilters;
  FacetFiltersForm.renderFilters = function (parsedHTML, event) {
    snklRenderFilters.call(FacetFiltersForm, parsedHTML, event);
    snklFillMobileFacets();
  };
  snklFillMobileFacets();
})();


/* SNKL 2026-09-06: lupka w panelu filtra (zgloszenie usera). Delegowany na dokumencie,
   bo Dawn po kazdej zmianie filtra podmienia innerHTML OBU formularzy - handler wpiety
   w konkretne pole nie przezylby renderu. Ukrywanie idzie przez wlasciwosc `hidden`,
   nie przez klase `hidden` Dawna, zeby nie kolidowac z mechanizmem „pokaz wiecej". */
(function () {
  function snklFacetFind(pole) {
    var panel = pole.closest('.facets__display, .facets__display-vertical, .mobile-facets__submenu');
    if (!panel) return;
    var fraza = (pole.value || '').trim().toLowerCase();
    var wiersze = panel.querySelectorAll('li.facets__item, li.mobile-facets__item');
    var widocznych = 0;
    for (var i = 0; i < wiersze.length; i++) {
      var pasuje = fraza === '' || (wiersze[i].textContent || '').toLowerCase().indexOf(fraza) !== -1;
      wiersze[i].hidden = !pasuje;
      if (pasuje) widocznych++;
    }
    var pusto = panel.querySelector('[data-snkl-facet-empty]');
    if (pusto) pusto.hidden = widocznych !== 0;
  }
  /* FAZA CAPTURE + stopPropagation (2026-09-08, zgloszenie usera: „wpisuje tekst, po 2 sekundach
     znika z pola i nic sie nie wyszukuje"). Pole lupki siedzi WEWNATRZ <form> filtrow, a Dawn
     wiesza na formularzu `input` -> debounce (800 ms, od 2026-10-07 400 ms) -> onSubmitHandler -> fetch sekcji ->
     podmiana innerHTML OBU formularzy. Kazda litera liczyla sie wiec jako zmiana filtra i po
     niecalych 2 s wracal swiezy HTML: pole puste, wiersze znow widoczne. Capture na dokumencie
     odpala PRZED listenerem formularza, a stopPropagation nie dopuszcza zdarzenia do niego.
     Zdarzen z pol filtrow (checkbox, cena) to nie dotyczy - stoja poza [data-snkl-facet-find]. */
  document.addEventListener('input', function (e) {
    var pole = e.target && e.target.closest && e.target.closest('[data-snkl-facet-find]');
    if (!pole) return;
    e.stopPropagation();
    snklFacetFind(pole);
  }, true);
  /* Escape czysci pole zamiast zamykac panel */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var pole = e.target && e.target.closest && e.target.closest('[data-snkl-facet-find]');
    if (!pole || pole.value === '') return;
    e.stopPropagation();
    pole.value = '';
    snklFacetFind(pole);
  });
})();


/* SNKL 2026-10-07: zmiana filtra bez utraty miejsca na liście i z wejściem kart.
   1) W szufladzie mobilnej przewija się sam <ul.mobile-facets__list>, a renderMobileCounts
      podmienia jego outerHTML pustą listą z serwera (wartości dokleja dopiero klonowanie
      wyżej), więc po każdym zaznaczeniu lista wracała na górę. Na desktopie podmiana
      .facets__header kasowała frazę lupki. Stan otwartych filtrów zapisujemy przed
      renderem i przywracamy po klonowaniu.
   2) renderProductGridContainer dokleja scroll-trigger--cancel do WSZYSTKICH nowych kart,
      więc karty w kadrze pojawiały się skokiem. Karty w kadrze dostają wejście slideIn
      kaskadą od zera, karty pod kadrem wjeżdżają przy przewijaniu jak dotąd. Przy otwartej
      szufladzie wejście czeka na jej zamknięcie (inaczej odegrałoby się pod nakładką). */
(function () {
  var LISTY = '.mobile-facets__list, .facets__display, .facets__display-vertical';
  var ruch = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function zapiszStan() {
    var stan = [];
    var filtry = document.querySelectorAll('#FacetFiltersForm .js-filter[open], #FacetFiltersFormMobile .js-filter[open]');
    for (var i = 0; i < filtry.length; i++) {
      var lista = filtry[i].querySelector(LISTY);
      var pole = filtry[i].querySelector('[data-snkl-facet-find]');
      stan.push({ id: filtry[i].id, top: lista ? lista.scrollTop : 0, fraza: pole ? pole.value : '' });
    }
    return stan;
  }

  function przywrocStan(stan, event) {
    for (var i = 0; i < stan.length; i++) {
      var filtr = document.getElementById(stan[i].id);
      if (!filtr) continue;
      var pole = filtr.querySelector('[data-snkl-facet-find]');
      if (pole && stan[i].fraza) {
        pole.value = stan[i].fraza;
        /* przechwytuje handler lupki (capture + stopPropagation), formularz go nie widzi */
        pole.dispatchEvent(new Event('input', { bubbles: true }));
      }
      var lista = filtr.querySelector(LISTY);
      if (lista && stan[i].top) lista.scrollTop = stan[i].top;
    }
    /* Dawn szuka klikniętego pola, zanim klonowanie wypełni listę, i oddaje fokus
       przyciskowi zamknięcia; wracamy z nim na pole, bez przewijania. */
    var cel = event && event.target;
    if (!cel || !cel.id || cel.getAttribute('type') === 'text') return;
    var nowe = document.getElementById(cel.id);
    if (nowe && nowe !== document.activeElement && nowe.closest('#FacetFiltersFormMobile')) {
      nowe.focus({ preventScroll: true });
    }
  }

  var snklRenderFilters = FacetFiltersForm.renderFilters;
  FacetFiltersForm.renderFilters = function (parsedHTML, event) {
    var stan = zapiszStan();
    snklRenderFilters.call(FacetFiltersForm, parsedHTML, event);
    przywrocStan(stan, event);
  };

  var czeka = null;

  function otwartaSzuflada() {
    var szuflada = document.querySelector('.mobile-facets__disclosure.menu-opening');
    return szuflada && szuflada.getClientRects().length ? szuflada : null;
  }

  function odegraj(karty) {
    for (var i = 0; i < karty.length; i++) {
      if (!karty[i].isConnected) continue;
      karty[i].style.setProperty('--animation-order', Math.min(i, 12));
      karty[i].classList.remove('scroll-trigger--cancel', 'snkl-grid-czeka');
    }
  }

  function wejscieKart() {
    if (czeka) {
      czeka.disconnect();
      czeka = null;
    }
    if (!ruch.matches) return;
    var siatka = document.getElementById('ProductGridContainer');
    if (!siatka) return;
    var karty = siatka.querySelectorAll('.grid__item.scroll-trigger.animate--slide-in');
    /* ten sam dolny margines co IntersectionObserver w animations.js */
    var dol = window.innerHeight - 50;
    var wKadrze = [];
    for (var i = 0; i < karty.length; i++) {
      var r = karty[i].getBoundingClientRect();
      if (r.bottom > 0 && r.top < dol) wKadrze.push(karty[i]);
    }
    if (!wKadrze.length) return;

    var szuflada = otwartaSzuflada();
    if (!szuflada) {
      odegraj(wKadrze);
      return;
    }
    for (var j = 0; j < wKadrze.length; j++) wKadrze[j].classList.add('snkl-grid-czeka');
    czeka = new MutationObserver(function () {
      if (szuflada.classList.contains('menu-opening')) return;
      czeka.disconnect();
      czeka = null;
      odegraj(wKadrze);
    });
    czeka.observe(szuflada, { attributes: true, attributeFilter: ['class'] });
  }

  var snklRenderGrid = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (parsedDoc) {
    snklRenderGrid.call(FacetFiltersForm, parsedDoc);
    wejscieKart();
  };
})();
